import { useMemo } from 'react';
import { AccountType } from '../enums';
import { useAccount } from './useAccount';

export function useExAccount(): boolean {
  const account = useAccount();
  return useMemo(() => account.type === AccountType.ACCOUNT_EX, [account]);
}
